<h2 class="page-title" mat-dialog-title>Delete Extension?</h2>
<mat-dialog-content class="mat-dialog-content-no-heading">
  <div class="confirmation-dialog-message">
    @if (autoAttendantExtensionList.length > 0) {
      <div>
        This extension is currently set as the Timeout Extension for the following Auto Attendant extension{{
        autoAttendantExtensionList.length > 1 ? 's' : ''
        }}:
        <ul class="extension-list">
          @for (extension of autoAttendantExtensionList; track extension) {
            <li>
              {{ extension.number }} - {{ extension.name }}
            </li>
          }
        </ul>
      </div>
    }
    @if (fmFmExtensionList.length > 0) {
      <div>
        @if (autoAttendantExtensionList.length > 0) {
          <p>
            And the Final Destination Extension for the following Find Me Follow Me extension{{
            fmFmExtensionList.length > 1 ? 's' : ''
            }}:
          </p>
        }
        @if (autoAttendantExtensionList.length == 0) {
          <p>
            This extension is currently set as the Final Destination Extension for the following Find Me Follow Me
            extension{{ fmFmExtensionList.length > 1 ? 's' : '' }}:
          </p>
        }
        <ul class="extension-list">
          @for (extension of fmFmExtensionList; track extension) {
            <li> {{ extension.number }} - {{ extension.name }} </li>
          }
        </ul>
      </div>
    }

    @if (huntGroupExtensionsList.length > 0) {
      <div>
        @if (autoAttendantExtensionList.length > 0 || fmFmExtensionList.length > 0) {
          <p>
            And the Route Busy or Route No Answer Extension for the following Hunt Group extension{{
            huntGroupExtensionsList.length > 1 ? 's' : ''
            }}:
          </p>
        }
        @if (autoAttendantExtensionList.length == 0 && fmFmExtensionList.length == 0) {
          <p>
            This extension is currently set as the Route Busy or Route No Answer Extension for the following Hunt Group
            extension{{ huntGroupExtensionsList.length > 1 ? 's' : '' }}:
          </p>
        }
        <ul class="extension-list">
          @for (extension of huntGroupExtensionsList; track extension) {
            <li> {{ extension.number }} - {{ extension.name }} </li>
          }
        </ul>
      </div>
    }

    @if (queueExtensionsList.length > 0) {
      <div>
        @if (
          autoAttendantExtensionList.length > 0 ||
          fmFmExtensionList.length > 0 ||
          huntGroupExtensionsList.length > 0
          ) {
          <p
            >
            And the Exit Route Extension for the following Queue extension{{
            queueExtensionsList.length > 1 ? 's' : ''
            }}:
          </p>
        }
        @if (
          autoAttendantExtensionList.length == 0 &&
          fmFmExtensionList.length == 0 &&
          huntGroupExtensionsList.length == 0
          ) {
          <p
            >
            This extension is currently set as the Exit Route Extension for the following Queue extension{{
            queueExtensionsList.length > 1 ? 's' : ''
            }}:
          </p>
        }
        <ul class="extension-list">
          @for (extension of queueExtensionsList; track extension) {
            <li> {{ extension.number }} - {{ extension.name }} </li>
          }
        </ul>
      </div>
    }
    @if (isUsedOnOtherExtensions) {
      <div>
        Clicking Yes will prompt callers who reach the above routes with an error message and disconnect the call. To
        avoid interruptions, update these routes to use a different extension before proceeding.
      </div>
    } @else {
      Are you sure you want to delete this extension?
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
  <button type="button" mat-button (click)="onCancel()" mat-dialog-close>No</button>
</mat-dialog-actions>